export enum AppSectionsCore {
    PROPERTIES = 'SupplierHotel',
    BOOKINGS = 'SupplierBooking',
    TAXES = 'Tax',
    SUPPLEMENTS = 'Supplement',
    CONTRACTS = 'StaticRateContract',
    STOP_SALES = 'SupplierHotelStopSale',
    ARI = 'ARI',
}

export enum AppSectionsZinantis {
    MEMBERS = 'ZinantisAgency',
    CONNECTION_REQUESTS = 'ZinantisConnectionRequest',
    CHANNEL_MANAGERS = 'ChannelManager',
}

export enum AppSectionsProfile {
    ACCOUNT = 'HotelOwner',
    CONTACTS = 'HotelOwnerContacts',
    PAYMENT = 'PaymentProfile',
    SETTINGS = 'Settings',
}

export enum AppSectionsZitoneo {
    HOTEL_CONTENT = 'HotelContent',
}

export enum AppSections {
    CORE = 'core',
    ZINANTIS = 'zinantis',
    PROFILE = 'profile',
    ZITONEO = 'zitoneo',
}

export interface IAppConfigSections {
    [AppSections.CORE]: {
        isVisible: boolean;
        pages: {
            [AppSectionsCore.PROPERTIES]: boolean;
            [AppSectionsCore.BOOKINGS]: boolean;
            [AppSectionsCore.TAXES]: boolean;
            [AppSectionsCore.SUPPLEMENTS]: boolean;
            [AppSectionsCore.CONTRACTS]: boolean;
            [AppSectionsCore.STOP_SALES]: boolean;
            [AppSectionsCore.ARI]: boolean;
        };
    };
    [AppSections.ZINANTIS]: {
        isVisible: boolean;
        pages: {
            [AppSectionsZinantis.MEMBERS]: boolean;
            [AppSectionsZinantis.CONNECTION_REQUESTS]: boolean;
            [AppSectionsZinantis.CHANNEL_MANAGERS]: boolean;
        };
    };
    [AppSections.PROFILE]: {
        isVisible: boolean;
        pages: {
            [AppSectionsProfile.ACCOUNT]: boolean;
            [AppSectionsProfile.CONTACTS]: boolean;
            [AppSectionsProfile.PAYMENT]: boolean;
            [AppSectionsProfile.SETTINGS]: boolean;
        };
    };
    [AppSections.ZITONEO]: {
        isVisible: boolean;
        pages: {
            [AppSectionsZitoneo.HOTEL_CONTENT]: boolean;
        };
    };
}

export interface IAppConfigFeatures {
    zitoneo: {
        serviceScraperPromptKey: string;
        competitorScrapingPromptKey: string;
    };
}

export interface IAppConfig {
    sections: IAppConfigSections;
    features: IAppConfigFeatures;
}

export enum AppConfigCoreSectionKey {
    SUPPLEMENTS = 'DEATHEATERS_SHOW_SUPPLEMENTS_INTERFACE',
    STOP_SALES = 'DEATHEATERS_SHOW_STOP_SALES_INTERFACE',
    CONTRACTS = 'DEATHEATERS_SHOW_STATIC_RATE_CONTRACTS_INTERFACE',
}

export enum AppConfigZitoneoSectionKey {
    ZINOTEO_SERVICE_ATTRIBUTES = 'DEATHEATERS_SHOW_ZITONEO_SERVICE_ATTRIBUTES_INTERFACE',
}

export enum OwnerConfigCoreSectionKey {
    SUPPLEMENTS = 'OWNER_SHOW_SUPPLEMENTS_INTERFACE',
    STOP_SALES = 'OWNER_SHOW_STOP_SALES_INTERFACE',
    CONTRACTS = 'OWNER_SHOW_STATIC_RATE_CONTRACTS_INTERFACE',
}

export enum OwnerConfigZitoneoSectionKey {
    ZINOTEO_SERVICE_ATTRIBUTES = 'OWNER_SHOW_ZITONEO_SERVICE_ATTRIBUTES_INTERFACE',
}

export enum AppConfigFeaturesZitoneo {
    ServiceScraperPromptKey = 'DEATHEATERS_ZITONEO_SERVICE_SCRAPER_PROMPT_KEY',
    CompetitorScrapingPromptKey = 'DEATHEATERS_ZITONEO_COMPETITOR_SCRAPER_PROMPT_KEY',
}
